import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const T = {
    nl: { pre: "Ik ga akkoord met de", terms: "algemene voorwaarden", and: "en de", privacy: "privacyverklaring" },
    fr: { pre: "J'accepte les", terms: "conditions générales", and: "et la", privacy: "déclaration de confidentialité" },
    en: { pre: "I agree to the", terms: "terms & conditions", and: "and the", privacy: "privacy policy" },
    es: { pre: "Acepto los", terms: "términos y condiciones", and: "y la", privacy: "política de privacidad" },
};

export default function TermsCheckbox({ checked, onChange }) {
    const { i18n } = useTranslation();
    const t = T[(i18n.language || "nl").slice(0, 2)] || T.nl;
    return (
        <label className="flex items-start gap-2.5 cursor-pointer select-none" data-testid="terms-checkbox-label">
            <input
                type="checkbox"
                required
                checked={checked}
                onChange={(e) => onChange(e.target.checked)}
                className="mt-0.5 h-4 w-4 accent-[#E5A93D] shrink-0"
                data-testid="terms-checkbox"
            />
            <span className="text-xs text-zinc-500 leading-relaxed">
                {t.pre}{" "}
                <Link to="/voorwaarden" target="_blank" className="text-[#E5A93D] hover:underline">{t.terms}</Link>{" "}
                {t.and}{" "}
                <Link to="/privacy" target="_blank" className="text-[#E5A93D] hover:underline">{t.privacy}</Link>.
            </span>
        </label>
    );
}
